const PREFIX = 'lykkevaerk'

/** Læser gemt data fra browserens localStorage. Falder tilbage til startdata. */
export function loadState<T>(key: string, fallback: T): T {
  if (typeof window === 'undefined') return fallback
  try {
    const raw = window.localStorage.getItem(`${PREFIX}:${key}`)
    if (!raw) return fallback
    return JSON.parse(raw) as T
  } catch {
    return fallback
  }
}

/**
 * Gemmer data i browserens localStorage.
 * Returnerer true hvis det lykkedes, så kaldere kan vise en fejl til brugeren.
 */
export function saveState<T>(key: string, value: T): boolean {
  if (typeof window === 'undefined') return false
  try {
    window.localStorage.setItem(`${PREFIX}:${key}`, JSON.stringify(value))
    return true
  } catch {
    return false
  }
}
